import React from 'react'
import ReactDOM from 'react-dom'
import CloseButton from '../../../../../../layout/close_button/CloseButton'
import DivButton from '../../../../../../layout/divbutton/DivButton'
import ModalWindow from '../../../../../../layout/modalwindow/ModalWindow'
import { FaCheck } from 'react-icons/fa'

function Schedule(props) {
  const schedule  = props.schedule
  const { updateSchedules, deleteSchedule, showAddNewScheduleForm, clientUsers, time_zone } = props

  const onClickChangeHeaderAndTime = (e) => {
    const close_button = e.target.closest('.close-button')
    if (close_button) return
    showAddNewScheduleForm(schedule)
  }

  const onClickDays = (e) => {
    const current_button = e.target.closest('.schedule-day-button')
    updateSchedules({...schedule, days: {...schedule.days, [current_button.id]: !(schedule.days[current_button.id])}})
  }

  const onClickUserCheck = (e) => {
    let sched = null
    const current_button = e.target.closest('.user-check-button')
    const user_id = parseInt(current_button.id)
    if (!schedule.users_list.find(ul => ul === user_id)) {
      sched = {...schedule, users_list: [...schedule.users_list, user_id]}
    } else {
      sched = {...schedule, users_list: [...schedule.users_list.filter(ul => ul !== user_id)]}
    }
    updateSchedules(sched)
  }

  const onClickDeleteSchedule = (e) => {
    const close_button = e.target.closest('.close-button')
    const onClick = (button) => {
      if (button === 'Yes') deleteSchedule(parseInt(close_button.id))
      ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
    }
    ReactDOM.render (
      <ModalWindow
        id='mw-parent'
        header='Delete Schedule'
        footer={null}>
        <div className='messagebox'>
          <div className='messagebox-content'>
            Are you sure you want to delete this schedule?
          </div>
          <div className='button-container'>
            <button onClick={() => { onClick('No') }} className='pospro-action-btn top-anchor'>No</button>
            <button onClick={() => { onClick('Yes') }} className='pospro-action-btn bottom-anchor'>Yes</button>
          </div>
        </div>
      </ModalWindow>,
      document.getElementById('modal-form-container')
    )
  }

  return (
    <div className='schedule-container'>
      <DivButton
        id='schedule-and-time'
        className='schedule-header-and-time-wrapper'
        onClick={onClickChangeHeaderAndTime}
        title='Change schedule title and time.'
        >
        <div className='schedule-title-header'>
          <div className='schedule-title'>{(schedule.title || 'Schedule Title')}</div>
          <div className='schedule-delete-button'>
            <CloseButton id={schedule.id} onClick={onClickDeleteSchedule} title='delete schedule'/>
          </div>
        </div>
        <div className='schedule-time-wrapper'>
          {
            (!schedule.time.all_the_time)
            ? <div className='schedule-time'>
                {`Time:
                  ${schedule.time.from.hour + ':' + schedule.time.from.minute + ' ' + schedule.time.from.state}
                  to
                  ${schedule.time.to.hour + ':' + schedule.time.to.minute + ' ' + schedule.time.to.state}
                `}
              </div>
            : <div className='schedule-time'>Time: All the time</div>
          }
          <div className='schedule-timezone'>{`Time Zone: ${time_zone}`}</div>
        </div>
      </DivButton>
      <div className='schedule-days-wrapper'>
        <button
          className='schedule-day-button'
          onClick={onClickDays}
          id='sunday'
          title='Sunday'>
          <div className='schedule-day'>S</div>
          <div className={schedule.days.sunday ? 'schedule-day-check' : 'schedule-day-check hide-check'}><FaCheck /></div>
        </button>
        <button
          className='schedule-day-button'
          onClick={onClickDays}
          id='monday'
          title='Monday'>
          <div className='schedule-day'>M</div>
          <div className={schedule.days.monday ? 'schedule-day-check' : 'schedule-day-check hide-check'}><FaCheck /></div>
        </button>
        <button
          className='schedule-day-button'
          onClick={onClickDays}
          value={schedule.days.tuesday}
          id='tuesday'
          title='Tuesday'>
          <div className='schedule-day'>T</div>
          <div className={schedule.days.tuesday ? 'schedule-day-check' : 'schedule-day-check hide-check'}><FaCheck /></div>
        </button>
        <button
          className='schedule-day-button'
          onClick={onClickDays}
          id='wednesday'
          title='Wednesday'>
          <div className='schedule-day'>W</div>
          <div className={schedule.days.wednesday ? 'schedule-day-check' : 'schedule-day-check hide-check'}><FaCheck /></div>
        </button>
        <button
          className='schedule-day-button'
          onClick={onClickDays}
          value={schedule.days.thursday}
          id='thursday'
          title='Thursday'>
          <div className='schedule-day'>Th</div>
          <div className={schedule.days.thursday ? 'schedule-day-check' : 'schedule-day-check hide-check'}><FaCheck /></div>
        </button>
        <button
          className='schedule-day-button'
          onClick={onClickDays}
          id='friday'
          title='Friday'>
          <div className='schedule-day'>F</div>
          <div className={schedule.days.friday ? 'schedule-day-check' : 'schedule-day-check hide-check'}><FaCheck /></div>
        </button>
        <button
          className='schedule-day-button'
          onClick={onClickDays}
          id='saturday'
          title='Saturday'>
          <div className='schedule-day'>S</div>
          <div className={schedule.days.saturday ? 'schedule-day-check' : 'schedule-day-check hide-check'}><FaCheck /></div>
        </button>
      </div>
      <div className='schedule-users-list-wrapper'>
        <div className='schedule-users-list-header'>User's</div>
        <table className='schedule-users-list-table'>
          <thead>
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>Designation</th>
              <th>Active</th>
            </tr>
          </thead>
          <tbody>
          {
            clientUsers.map(user => (
              <tr key={user.id}>
                <td>{user.id}</td>
                <td>{`${user.last_name}, ${user.first_name} ${user.middle_name}`}</td>
                <td>{user.designation}</td>
                <td>
                  <button
                    id={user.id}
                    onClick={onClickUserCheck}
                    className='user-check-button'>
                    <div className={schedule.users_list.find(ul => ul === user.id) ? 'user-check' : 'user-check hide-check'}><FaCheck/></div>
                  </button>
                </td>
              </tr>
            ))
          }
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default React.memo(Schedule)